import { render, staticRenderFns } from "./policy-tables-tab.vue?vue&type=template&id=33860970"
import script from "./policy-tables-tab.vue?vue&type=script&lang=js"
export * from "./policy-tables-tab.vue?vue&type=script&lang=js"
import style0 from "./policy-tables-tab.vue?vue&type=style&index=0&id=33860970&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports